import { forwardRef } from 'react'
import { default as Svg } from 'react-inlinesvg'
import { SVGByNameProps, SVGProps } from './props'
import { StyledSVG } from './styles'
/*eslint import/namespace: ['error', { allowComputed: true }]*/
import * as Assets from '../../Assets/Icons'

const SVG = forwardRef<Svg, SVGProps>((props, ref) => (
    <StyledSVG {...props} ref={ref} />
))

const SVGByName = forwardRef<Svg, SVGByNameProps>(({ name, ...props }, ref) => {
    const src = Assets[name] ?? Assets.Error404
    return <SVG {...props} ref={ref} src={src} />
})

SVG.displayName = 'SVG'
SVGByName.displayName = 'SVGByName'

export default SVG

export { StyledSVG, SVGByName }
